import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import firebase from "gatsby-plugin-firebase";

// Initial state
export const initialState = {
  favoriteJobs: [],
  hasFulfilled: false,
};

// Thunks
export const getFavoriteJobs = createAsyncThunk(
  "jobs/getFavoriteJobs",
  async () => {
    try {
      const querySnapshot = await firebase
        .firestore()
        .collection("job-posts")
        .where("trackedBy", "array-contains", firebase.auth().currentUser.uid)
        .get();

      if (querySnapshot.empty) {
        // There are no favorite jobs
        return [];
      } else {
        // Return an array of favorite jobs
        return querySnapshot.docs.map((doc) => {
          const data = { ...doc.data(), id: doc.id };

          // Date object is not serializable, so convert to milliseconds
          if (data.dateAdded !== undefined) {
            data.dateAdded = data.dateAdded.toMillis();
          }
          if (data.expires !== undefined) {
            data.expires = data.expires.toMillis();
          }

          return data;
        });
      }
    } catch (error) {
      // Log an event
      firebase.analytics().logEvent("get_favorite_jobs", {
        errorCode: error.code,
        errorMsg: error.message,
      });

      // Return as if there are no favorite jobs
      return [];
    }
  }
);

// Slice
export const favoritesSlice = createSlice({
  name: "favorites",
  initialState: initialState,
  reducers: {
    addFavorite: (state, action) => {
      state.favoriteJobs.push(action.payload);
    },
    removeFavorite: (state, action) => {
      state.favoriteJobs = state.favoriteJobs.filter(
        (job) => job.id !== action.payload
      );
    },
  },
  extraReducers: {
    [getFavoriteJobs.fulfilled]: (state, action) => {
      state.hasFulfilled = true;
      state.favoriteJobs = action.payload;
    },
  },
});

// Selectors
export const selectFavoriteJobs = (state) => state.favorites.favoriteJobs;
export const selectFavoriteJobsHasFulfilled = (state) =>
  state.favorites.hasFulfilled;
export const selectActiveFavorites = (state) =>
  state.favorites.favoriteJobs.filter((job) => job.active);
export const selectInactiveFavorites = (state) =>
  state.favorites.favoriteJobs.filter((job) => !job.active);

// Exports
export const { addFavorite, removeFavorite } = favoritesSlice.actions;
export default favoritesSlice.reducer;
